import { Skeleton, SkeletonRow } from "@/components/ui";

export function RouteLoading() {
  return (
    <div className="p-8 max-w-[1200px] mx-auto" role="status" aria-live="polite" aria-label="Cargando vista">
      <Skeleton width={256} height={28} className="mb-3" />
      <Skeleton width={384} height={16} className="mb-6" />
      <div className="rounded-lg border border-border bg-surface p-4">
        <SkeletonRow />
        <SkeletonRow />
        <SkeletonRow />
        <SkeletonRow />
      </div>
    </div>
  );
}
